var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2830_853)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92868 1.57143C3.72029 1.57143 3.52044 1.65421 3.37309 1.80156C3.22574 1.94891 3.14296 2.14876 3.14296 2.35714V19.6429C3.14296 19.8512 3.22574 20.0511 3.37309 20.1984C3.52044 20.3458 3.72029 20.4286 3.92868 20.4286H18.0715C18.2799 20.4286 18.4798 20.3458 18.6271 20.1984C18.7745 20.0511 18.8572 19.8512 18.8572 19.6429V8.96831L11.4604 1.57143H3.92868ZM2.26192 0.690391C2.70397 0.248341 3.30352 0 3.92868 0H11.7858C11.9942 0 12.1941 0.0827804 12.3414 0.23013L20.1985 8.08727C20.3459 8.23462 20.4287 8.43447 20.4287 8.64286V19.6429C20.4287 20.268 20.1803 20.8676 19.7383 21.3096C19.2962 21.7517 18.6967 22 18.0715 22H3.92868C3.30352 22 2.70397 21.7517 2.26192 21.3096C1.81987 20.8676 1.57153 20.268 1.57153 19.6429V2.35714C1.57153 1.73199 1.81987 1.13244 2.26192 0.690391Z",
    fill: "#FF8503"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28589 7.07143C6.28589 6.63749 6.63766 6.28571 7.0716 6.28571H10.2145C10.6484 6.28571 11.0002 6.63749 11.0002 7.07143C11.0002 7.50537 10.6484 7.85714 10.2145 7.85714H7.0716C6.63766 7.85714 6.28589 7.50537 6.28589 7.07143Z",
    fill: "#FF8503"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28589 11.7857C6.28589 11.3518 6.63766 11 7.0716 11H14.9287C15.3627 11 15.7145 11.3518 15.7145 11.7857C15.7145 12.2197 15.3627 12.5714 14.9287 12.5714H7.0716C6.63766 12.5714 6.28589 12.2197 6.28589 11.7857Z",
    fill: "#FF8503"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28589 16.5C6.28589 16.0661 6.63766 15.7143 7.0716 15.7143H14.9287C15.3627 15.7143 15.7145 16.0661 15.7145 16.5C15.7145 16.9339 15.3627 17.2857 14.9287 17.2857H7.0716C6.63766 17.2857 6.28589 16.9339 6.28589 16.5Z",
    fill: "#FF8503"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2830_853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCardIcon);
export default __webpack_public_path__ + "static/media/fileCardIcon.5da87eee6dc7e66162911614a9f07088.svg";
export { ForwardRef as ReactComponent };